import type { OsasResendMijnKsyosQuestionnairesData } from '@common/validation/customControls/osas/osasResendMijnKsyosQuestionnairesSchema';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from './osasResendMijnKsyosQuestionnairesData';
import { OsasResendMijnKsyosQuestionnairesEdit } from './OsasResendMijnKsyosQuestionnairesEdit';
import { OsasResendMijnKsyosQuestionnairesRead } from './OsasResendMijnKsyosQuestionnairesRead';

CustomControlRegistry.instance.register<OsasResendMijnKsyosQuestionnairesData>({
    EditElement: OsasResendMijnKsyosQuestionnairesEdit,
    ReadElement: OsasResendMijnKsyosQuestionnairesRead,
    code: CustomControlCode.OSASResendMijnKsyosQuestionnaires,
    initialData,
    version: 1,
});
